/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import InstitutesSettingsRouteLinkItem from './InstitutesSettingsRouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.institutes.forms'},
});

const FormsItem = () => (
  <InstitutesSettingsRouteLinkItem
    route="midas/settings/institutes/forms"
    title={messages.title}
  />
);

export default FormsItem;
